// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__2Y1f9","btn_diamond":"Abutton_btn_diamond__2_8W2","btn_bagcolor":"Abutton_btn_bagcolor__BDby5"};